import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiIconButton-label': {
      color: (props) => (props?.disabled ? theme.disableColor : theme.palette.primary.main),
    },
  },
}));
